import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { AppHeader } from "@/components/AppHeader";
import { useApi, errMsg, fmtDateTime } from "@/lib/api";
import { useMe } from "@/context/MeContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const LABELS = { admin: "Administrador", member: "Equipe", pending: "Aguardando aprovação" };

export default function UsersPage() {
  const api = useApi();
  const me = useMe();
  const [data, setData] = useState(null);

  const load = useCallback(() => {
    if (me.role !== "admin") return;
    api.get("/users").then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [api, me.role]);
  useEffect(() => { load(); }, [load]);

  const change = async (uid, role) => {
    try { await api.patch(`/users/${uid}/role`, { role }); toast.success("Acesso atualizado"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  if (me.role !== "admin") return <div className="p-8 text-slate-400">Acesso restrito.</div>;
  const pending = data?.users.filter((u) => u.role === "pending").length || 0;

  return (
    <div className="min-h-screen">
      <AppHeader back="/" title="Equipe" subtitle={pending ? `${pending} aguardando aprovação` : "Controle de acesso"} />
      <main className="max-w-3xl mx-auto px-4 py-8 space-y-4">
        <p className="text-sm text-slate-400">Novas pessoas entram como "Aguardando aprovação". Mude para "Equipe" para liberar o checklist.</p>
        <ul className="space-y-2" data-testid="users-list">
          {data?.users.map((u) => (
            <li key={u.user_id} className={`rounded-lg border p-4 flex items-center gap-3 flex-wrap ${u.role === "pending" ? "border-[#FFB300]/50 bg-[#FFB300]/[0.05]" : "border-[#2A2E39] bg-[#15181E]"}`} data-testid={`user-row-${u.user_id}`}>
              <div className="flex-1 min-w-0">
                <div className="text-white font-semibold truncate">{u.name}</div>
                <div className="text-xs text-slate-400 truncate">{u.email}</div>
                <div className="font-mono text-[10px] text-slate-500 mt-1">desde {fmtDateTime(u.created_at)}</div>
              </div>
              <Select value={u.role} onValueChange={(r) => change(u.user_id, r)}>
                <SelectTrigger className="w-56 h-12 bg-[#0B0C10] border-[#2A2E39]" data-testid={`user-role-select-${u.user_id}`}>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-[#15181E] border-[#2A2E39] text-white">
                  {data.roles.map((r) => <SelectItem key={r} value={r} data-testid={`role-option-${r}`}>{LABELS[r] || r}</SelectItem>)}
                </SelectContent>
              </Select>
            </li>
          ))}
        </ul>
      </main>
    </div>
  );
}
